import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { PROMOTIONS_API_URL } from '@ribera-web/promociones-data-access';
import { KITCHEN_API_URL } from '@ribera-web/cocina-data-access';
import { CLIENTES_API_URL } from '@ribera-web/clientes-data-access';
import { apiInterceptor, API_URL, HttpLoadingInterceptor } from '@ribera-web/auth-data-access';
import { environment } from '../environments/environment';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { DialogService } from 'primeng/dynamicdialog';

export const appConfig: ApplicationConfig = {
  providers: [
    provideClientHydration(withEventReplay()),
    provideBrowserGlobalErrorListeners(),
    provideRouter(appRoutes, withComponentInputBinding()),
    provideAnimationsAsync(),
    { provide: API_URL, useValue: environment.apiGatewayUrl },
    { provide: PROMOTIONS_API_URL, useValue: environment.promotionsApiUrl },
    { provide: KITCHEN_API_URL, useValue: environment.kitchenApiUrl },
    { provide: CLIENTES_API_URL, useValue: environment.customersApiUrl },
    provideHttpClient(
      withInterceptors([apiInterceptor, HttpLoadingInterceptor])
    ),
    provideCharts(withDefaultRegisterables()),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false
        }
      }
    }),
    DialogService
  ]
};
